import SubmissionCheckout from './SubmissionCheckout';

export default SubmissionCheckout;
